/**
 * @file こだわり条件で条件を選択された時に該当する求人数を取得する
 */
'use strict'

import Common from '../../Utils/Common'

/**
 * @classname CountHitNum
 * @classdesc CountHitNum
 */
export default class CountHitNum {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('CountHitNum.constructor')
		this._$e = $e
		this._controller = controller
		this._$hit_num = $('#hit_num');
		this._$scope = $e.closest('body.detail-search')

		if ($e.attr('type') === 'search') {
			$e.on('search blur', () => this.getQuery())
		} else {
			//クリアボタンは、条件をクリアした後に条件をAPIで送る
			if($e.hasClass('btn')){
				$e.on('click', () => {
					this.clearSearchCondition(() => {
					  this.getQuery();
					});
				});
			}
			$e.on('click', () => this.getQuery())
		}
		this._controller.on('constHitNumComplete', () => this.onCountHitNumComplete());
	}

	/**
	 * clickのコールバック
	 *
	 * @memberof CountHitNum
	 * @return {undefined}
	 */
	getQuery() {
		console.log('CountHitNum.getQuery')
		this._controller.countHitNum(Common.getApiSearchQuery(this._$scope));
	}

	/**
	 * 該当する求人数の表示
	 *
	 * @memberof CountHitNum
	 * @return {undefined}
	 */
	 onCountHitNumComplete() {
		console.log('CountHitNum.onCountHitNumComplete');
		const hitData = Common.separatedByComma(this._controller._hitData.hit_num);
		this._$hit_num.text(hitData)
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof ClearSearchCondition
	 * @return {undefined}
	 */
	 clearSearchCondition(callback) {
		console.log('CountHitNum.ClearSearchCondition')

		let $tagetBtn
		if(this._$e.hasClass('btn--clear-all')){
			$tagetBtn = this._$e.closest('body.detail-search').find('.input-checkbox-btn .input-checkbox-btn__input')
			this._$e.closest('body.detail-search').find('.freeword .input-search').val('')
			console.log('all clear::' + $tagetBtn)
		}else{
			$tagetBtn = this._$e.closest('dl').find('.input-checkbox-btn .input-checkbox-btn__input')
		}

		$tagetBtn.each((idx, e) => {
			const $e = $(e);
			$e.removeClass('active')
			$e.prop('checked', false)

			const modalId = $e.attr('data-target')
			const modal = $(`${modalId}`)
			if(modal[0]) {
				const modalBtn = modal.find('.input-checkbox-btn .input-checkbox-btn__input')
				modalBtn.each((idx, e) => {
					const $e = $(e);
					$e.prop('checked', false)
				});
			}
		});
		callback();
	}
}
